// Phases live inside Areas. Structures keeps the original three phases;
// Religion and Language are new single-phase areas.
export const PHASES = [
  { key: "pyramids", label: "Pyramids", roman: "I", color: "#9A3412", area: "structures" },
  { key: "glyphs", label: "Glyphs & Rock Art", roman: "II", color: "#0E7490", area: "structures" },
  { key: "megaliths", label: "Megaliths", roman: "III", color: "#4D7C0F", area: "structures" },
  { key: "religion", label: "Religion", roman: "", color: "#9F1239", area: "religion" },
  { key: "language", label: "Language", roman: "", color: "#1D4ED8", area: "language" },
];

export const PHASE_MAP = Object.fromEntries(PHASES.map((p) => [p.key, p]));

export const AREAS = [
  {
    key: "structures",
    label: "Structures",
    color: "#9A3412",
    phases: ["pyramids", "glyphs", "megaliths"],
    blurb: "Pyramids, glyphs and megaliths whose engineering, alignments or purpose still resist explanation.",
  },
  {
    key: "religion",
    label: "Religion",
    color: "#9F1239",
    phases: ["religion"],
    blurb: "Lost cults, mystery religions and unexplained sacred artifacts whose meaning and rites are forgotten.",
  },
  {
    key: "language",
    label: "Language",
    color: "#1D4ED8",
    phases: ["language"],
    blurb: "Undeciphered scripts, extinct tongues and inscriptions no living person can fully read.",
  },
];

export const AREA_MAP = Object.fromEntries(AREAS.map((a) => [a.key, a]));

export const areaOfPhase = (phase) => PHASE_MAP[phase]?.area || "structures";

// Badge text: structures show "III · Megaliths"; religion/language show just the label.
export const phaseBadge = (phase) => {
  const ph = PHASE_MAP[phase] || PHASE_MAP.pyramids;
  return ph.roman ? `${ph.roman} · ${ph.label}` : ph.label;
};

export const phaseColor = (phase) => (PHASE_MAP[phase] || PHASE_MAP.pyramids).color;
export const phaseLabel = (phase) => (PHASE_MAP[phase] || PHASE_MAP.pyramids).label;


// Archaeological era bands for the Timeline (years, BCE negative).
export const ERAS = [
  { key: "paleolithic", label: "Paleolithic", from: -Infinity, to: -10000 },
  { key: "neolithic", label: "Neolithic", from: -10000, to: -3300 },
  { key: "bronze", label: "Bronze Age", from: -3300, to: -1200 },
  { key: "iron", label: "Iron Age", from: -1200, to: -550 },
  { key: "classical", label: "Classical", from: -550, to: 500 },
  { key: "medieval", label: "Medieval", from: 500, to: 1500 },
  { key: "modern", label: "Modern Era", from: 1500, to: Infinity },
];

export const eraOfYear = (yr) => ERAS.find((e) => yr >= e.from && yr < e.to) || ERAS[ERAS.length - 1];
